import type { Claims } from '@mntn-dev/authentication-types'
import {
  OrganizationId,
  SessionId,
  type UserDomainSelectModel,
  UserId,
  UserUrn,
} from '@mntn-dev/domain-types'

import type { Principal } from './principal.ts'
import type { AuthorizedSession } from './session.ts'

export const SystemUserId = UserId.Empty
export const SystemOrganizationId = OrganizationId.Empty

export const SystemClaims: Claims = {
  // iss: 'n/a',
  // sub: 'n/a',
  // iat: 0,
  // nbf: Number.MIN_VALUE,
  // exp: Number.MAX_VALUE,
  // jti: 'n/a',
  // org_id: null,
  // org_name: null,
  // org_slug: null,
  // full_name: 'System User',
  last_name: 'User',
  first_name: 'System',
  // created_at: 0,
  // external_id: null,
  primary_email: 'system@quickframe.com',
  // email_verified: true,
  // last_signed_in: 0,
  // org_permissions: null,
}

export const SystemUser: UserDomainSelectModel = {
  emailAddress: 'system@quickframe.com',
  firstName: 'System',
  lastName: 'User',
  displayName: 'System User',
  initials: 'SU',
  isActive: true,
  userId: SystemUserId,
  userUrn: UserUrn(SystemUserId),
  organizationId: SystemOrganizationId,
  organizationType: 'internal',
  signUpTimestamp: new Date(),
  lastUpdatedTimestamp: new Date(),
}

export type SystemUser = typeof SystemUser

export const SystemPrincipal: Principal = {
  authz: {
    privileges: ['all'],
    isActive: true,
    organizationId: SystemUser.organizationId,
    teamIds: [],
    organizationType: 'internal',
    isSystem: true,
    partnerPrograms: [],
  },
  profile: {
    ...SystemUser,
  },
}

export const SystemSession: AuthorizedSession = {
  authn: {
    userId: '',
    sessionId: SessionId(),
    claims: SystemClaims,
  },
  ...SystemPrincipal,
}
